import type {Item} from 'shells/grid-selector/grid-selector';
import {
    CalendarIcon,
    PhoneCallIcon,
    EmailIcon,
    CommentIcon,
    CogIcon,
    VoicemailIcon,
    AudienceIcon,
    AlarmClockIcon,
    CompanyTypeIcon,
    LightbulbBrightIcon,
    VirtualMeetingIcon,
    StarIcon,
    Pencil,
    MeetingIcon,
    SidebarIconNotificationsIcon,
    BookIcon,
    HeartIcon,
    HomeIcon,
    FlagIcon,
    TrophyIcon,
} from 'shells/icon';

export const ACTIVITY_TYPE_ICONS = {
    DEFAULT: CalendarIcon,
    ALARM: AlarmClockIcon,
    BELL: SidebarIconNotificationsIcon,
    BOOK: BookIcon,
    BRIEFCASE: CompanyTypeIcon,
    CHAT: CommentIcon,
    EMAIL: EmailIcon,
    FLAG: FlagIcon,
    GEAR: CogIcon,
    HANDSHAKE: MeetingIcon,
    HEART: HeartIcon,
    HOME: HomeIcon,
    LIGHTBULB: LightbulbBrightIcon,
    PENCIL: Pencil,
    PEOPLE: AudienceIcon,
    PHONE: PhoneCallIcon,
    STAR: StarIcon,
    TROPHY: TrophyIcon,
    VIDEO: VirtualMeetingIcon,
    VOICEMAIL: VoicemailIcon,
} as const;

export const ACTIVITY_TYPE_ICONS_ITEMS: Array<Item> = Object.entries(ACTIVITY_TYPE_ICONS).map(
    ([id, content]: [any, any]) => ({
        id,
        type: 'icon',
        content,
    })
);
